import { render, staticRenderFns } from "./BenefitTreeNode.vue?vue&type=template&id=11cd1bd2"
import script from "./BenefitTreeNode.vue?vue&type=script&lang=js"
export * from "./BenefitTreeNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports